

























import importFiles from '@/apis/course/importFiles';
import { Component, Vue, Prop, PropSync, Emit } from 'vue-property-decorator';
import { updateMyCourseInfo } from '@/apis/courseList/courseList';
import i18n from '@/lang';

@Component({})
export default class extends Vue {
  @PropSync('show', { type: Boolean, default: false }) checkInfoShow!: boolean;
  @PropSync('roleObj', { type: Object, default: () => {} }) checkInfo!: any;
  @Prop({ type: String, default: '' }) courseId!: string;

  private selectDate = new Date();
  private minDate = new Date(1990, 0, 1);
  private timeShow = false;
  private gradeShow = false;
  private columns: Array<string> = ['1', '2', '3', '4', '5', '6'];

  // 入学时间
  formatter(type: string, val: string) {
    if (type === 'year') {
      return `${val} ${i18n.t('ktpMy.年') }`;
    }
    if (type === 'month') {
      return `${val} ${i18n.t('ktpMy.月')}`;
    }
    return val;
  }
  confim(val: any, index: any) {
    this.checkInfo.enrolltime = this.$moment(this.selectDate).format('YYYY-MM'); // 入学时间
    this.timeShow = false;
  }
  cancel() {
    this.timeShow = false;
  }

  // 选择年级
  gradeConfirm(val: string) {
    this.checkInfo.grade = val;
    this.gradeShow = false;
  }

  // 校验
  beforeClose(action: any, done: any) {
    const from = this.$refs.form as any;
    if (action === 'confirm') {
      (from.validate() as Promise<void>)
        .then(() => {
          (this.updateMyCourseInfo() as Promise<void>).then(() => {
            this.onSuccess();
            done();
          });
        })
        .catch(() => {
          done(false);
        });
    } else {
      from.resetValidation();
      done();
    }
  }

  // 更新资料
  updateMyCourseInfo(): Promise<void>  {
    return new Promise((resolve, reject) => {
      updateMyCourseInfo({
        courseid: this.courseId,
        data: this.checkInfo
      }).then(() => {
        resolve();
        this.$toast.success(i18n.t('Common.完善成功'));
      });
    });
  }

  // 上报成功事件
  @Emit('on-success')
  onSuccess() {
    return true;
  }
}
